import React, { Component, useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const ProtectedRoute = ({component: Component, ...rests}) => {
    const {userState, resetUserState} = useContext(AuthContext);

    return (  
        <Route {...rests} render={
            (props) => {
                if(userState.isAuthenticated)
                {
                    return <Component {...props} />
                }
                else
                {
                    resetUserState();
                    return <Redirect to={
                        {
                            pathname: "/",
                            state: {
                                from: props.location
                            }
                        }
                    }/>
                }
            }
        }/>
    );
}
 
export default ProtectedRoute;